import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Home, HelpCircle, Phone, Settings, Briefcase, CalendarDays, Award, Building2 } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';

const BottomNav = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { isAdmin, canAccessBusiness } = useAuth();

  const navItems = [
    { key: 'home', icon: Home, label: 'Home', path: '/' },
    { key: 'spille', icon: Award, label: 'Spille', path: '/spille' },
    { key: 'carriera', icon: Briefcase, label: 'Carriera', path: '/carriera' },
    { key: 'calendario', icon: CalendarDays, label: 'Calendario', path: '/calendario' },
    { key: 'contatti', icon: Phone, label: 'Contatti', path: '/contatti' },
    { key: 'faq', icon: HelpCircle, label: 'FAQ', path: '/faq' },
    ...(canAccessBusiness ? [{ key: 'business', icon: Building2, label: 'Business', path: '/business' }] : []),
    ...(isAdmin ? [{ key: 'admin', icon: Settings, label: 'Admin', path: '/admin' }] : []),
  ];

  const isActive = (path) => location.pathname === path || (path === '/business' && location.pathname.startsWith('/business'));

  return (
    <div
      className="md:hidden fixed inset-x-0 bottom-0 z-[100] pointer-events-none flex justify-center px-2.5 sm:px-4"
      style={{
        paddingBottom:
          'calc(var(--bottom-nav-float-gap) + var(--bottom-nav-label-inset) + env(safe-area-inset-bottom, 0px))',
      }}
    >
      <nav
        className="bottom-nav-glass bottom-nav-inner pointer-events-auto flex w-full max-w-lg items-stretch justify-between gap-0 rounded-[1.75rem] px-1 py-1 shadow-[0_8px_28px_rgba(15,23,42,0.1)]"
        aria-label="Navigazione principale"
      >
        {navItems.map((item) => {
          const active = isActive(item.path);
          return (
            <button
              key={item.key}
              type="button"
              onClick={() => navigate(item.path)}
              className="flex min-w-0 flex-1 flex-col items-center justify-center gap-0.5 rounded-2xl px-0.5 py-0.5 transition-colors duration-200"
              data-testid={`bottom-nav-${item.label.toLowerCase()}`}
              aria-current={active ? 'page' : undefined}
            >
              <span
                className={`bottom-nav-icon-wrap flex h-8 w-8 shrink-0 items-center justify-center rounded-full transition-all duration-200 ${
                  active ? 'is-active' : ''
                }`}
              >
                <item.icon
                  className="bottom-nav-icon h-[19px] w-[19px]"
                  strokeWidth={active ? 2.4 : 2.15}
                  aria-hidden
                />
              </span>
              <span
                className={`bottom-nav-item-label w-full truncate text-center text-[8px] font-semibold leading-none tracking-tight sm:text-[9px] ${
                  active ? 'is-active' : ''
                }`}
              >
                {item.label}
              </span>
            </button>
          );
        })}
      </nav>
    </div>
  );
};

export default BottomNav;
